<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <h3 class="mb-0">Visitors</h3>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      empty-text="No Visitors"
      :data="visitors"
    >
      <el-table-column label="IP" min-width="150px" prop="ip" sortable />
      <el-table-column
        label="Referrer"
        min-width="130px"
        prop="referrer"
        sortable
      />
      <el-table-column label="Date" min-width="160px" prop="createdAt" sortable>
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm">{{
              new Date(row.createdAt).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                timeZone: 'UTC'
              })
            }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Country"
        min-width="160px"
        prop="country_flag"
        sortable
      />
      <el-table-column
        label="Language"
        min-width="140px"
        prop="language"
        sortable
      />
      <el-table-column
        label="Additional Info"
        min-width="120px"
        prop="additionalInfo"
        label-class-name="text-break"
      />
    </el-table>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from 'element-ui'

export default {
  name: 'StatisticsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    visitors: Array
  }
}
</script>

<style scoped></style>
